<template>
  <div
    id="services"
    class="services"
  >
    <h1>Our services</h1>
    <div class="tiles">
      <div
        @click="toggleTile(index)"
        v-for="(tileText, index) in $t('services')"
        :key="index"
        :class="{ flipped: turnedTiles.includes(index) }"
      >
        <div
          class="card-front"
          :class="{ 'should-be-hidden': turnedTiles.includes(index) }"
        >
          {{ tileText.pile }}
        </div>
        <div
          class="card-back"
          :class="{ 'should-be-hidden': !turnedTiles.includes(index) }"
        >
          {{ tileText.face }}
        </div>
        <font-awesome-icon
          class="flipper"
          icon="fa-solid fa-repeat"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ServicesList",
    props: [],
    data: function () {
      return {
        turnedTiles: []
      };
    },
    computed: {},
    methods: {
      toggleTile(index) {
        var i = this.turnedTiles.indexOf(index);
        if (i === -1) this.turnedTiles.push(index);
        else this.turnedTiles.splice(i, 1);
      }
    }
  };
</script>

<style scoped>
  .should-be-hidden {
    display: none !important;
  }
  .services {
    padding-top: 2rem;
    font-size: 1.5rem;
    background: linear-gradient(
      180deg,
      var(--flatui-color1) 0%,
      var(--flatui-color3) 100%
    );
    padding-bottom: 2rem;
  }
  .tiles {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    grid-gap: 1.5em;
    padding: 2rem;
    perspective: 1000px;
  }
  .tiles > div {
    position: relative;
    aspect-ratio: 1 / 1;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    cursor: pointer;
    overflow: hidden;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .tiles > div.flipped {
    transform: rotateY(180deg);
  }
  .card-front {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1.5rem;
    padding-top: 2rem;
    gap: 0.75rem;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    transform: rotateY(0deg);
    color: var(--flatui-color4);
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.05) 100%
    );
    z-index: 1;
  }
  .card-front.should-be-hidden {
    z-index: -1;
  }
  .card-back {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1.5rem;
    padding-top: 2rem;
    gap: 0.75rem;
    transform: rotateY(180deg);
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    color: var(--flatui-color4);
    background: linear-gradient(
      135deg,
      var(--flatui-color2) 0%,
      var(--flatui-color6) 100%
    );
    font-size: 1rem;
    border-radius: 16px;
    z-index: -1;
  }
  .card-back.should-be-hidden {
    z-index: 1;
  }
  .tiles > div::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      var(--flatui-color5) 0%,
      var(--flatui-color6) 100%
    );
    opacity: 0;
    transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: -1;
  }
  .flipper {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: 0.85rem;
    opacity: 0.6;
    transition: opacity 0.3s;
    z-index: 10;
  }
  .tiles > div.flipped .flipper {
    transform: rotateY(180deg);
  }
  .tiles > div:hover {
    border-color: var(--flatui-color5);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  }
  .tiles > div:hover::before {
    opacity: 0.9;
  }
</style>
